export const QUALIFYING_TAX_AMNT = 30100;
